module.exports = __webpack_public_path__ + "img/image16@3x.6c7da913.png";